import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { myTimesheetUserRequestsPageRoutePath } from "my-timesheet/configs/routes";
import {
  useMyTimesheetDashboardDate,
  useMyTimesheetRequestsBadge,
} from "my-timesheet/hooks";
import { useOcIsMobile } from "oc/hooks";
import { ocNarrowMenuState } from "states";

export const useMyTimesheetAppbarBadge = (): {
  handleClick: () => void;
  count: number;
} => {
  const history = useHistory();
  const isMobile = useOcIsMobile();

  const { periodStart, periodEnd } = useMyTimesheetDashboardDate(
    "examinerUserRequests",
  );

  const { data } = useMyTimesheetRequestsBadge({
    startDate: periodStart.toISOString(),
    endDate: periodEnd.toISOString(),
  });

  const [narrowMenuOpened, setNarrowMenuOpened] =
    useRecoilState(ocNarrowMenuState);

  const count = data ?? 0;

  const handleClick = () => {
    if (isMobile) {
      setNarrowMenuOpened(!narrowMenuOpened);
    }
    history.push(`${myTimesheetUserRequestsPageRoutePath}?activeTab=1`);
  };

  return { handleClick, count };
};
